<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xpv59Y/tc-custom/9781595554314.jpg?1705214735393" alt="This image is the cover for the book Lee, The Generals Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lee, The Generals Series
      </h1>
      <p class="bookDescription body article font2">
        <b>A biography of the often misunderstood, yet heroic, Confederate general who sacrificed everything for his native state of Virginia during the Civil War. </b><br/><br/>Traitor. Divider. Defender of slavery. This damning portrayal of Robert E. Lee has persisted through 150 years of history books. And yet it has no basis in fact.<br/><br/>In the spirit of bold restoration, Lee: A Life of Virtue reveals the true Lee—passionate patriot, caring son, devoted husband, doting father, don’t-tread-on-me Virginian, Godfearing Christian.<br/><br/>Weaving forgotten facts and revelations (Lee considered slavery a moral outrage) with striking personal details (for years he carried his weakened mother to and from her carriage), biographer John Perry crafts a compelling treatment of the virtuous warrior who endured withering opposition and sacrificed all to stand for Constitutional freedoms.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Perry
      </h2>
      
      <p class="authorDescription body article"><P>John Perry graduated cum laude from Vanderbilt University, with additional studies at University College, Oxford, England. Before beginning his career as an author in 1997, he was an award-winning advertising copywriter and radio producer. John has published 21 books as an author, collaborator, or ghostwriter. He is the biographer of Sgt. Alvin York, Mary Custis Lee (wife of Robert E. Lee and great granddaughter of Martha Washington), and George Washington Carver. Among other books, he has also written about the 1925 Scopes “monkey” trial (Monkey Business, with Marvin Olasky, B&amp;H Publishing, 2005) and contemporary prison reform (God Behind Bars, Thomas Nelson, 2006). He is a two-time Gold Medallion finalist and Lincoln Prize nominee. He lives in Nashville.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8fb822cc